import AddBoxIcon from '@mui/icons-material/AddBox';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';

import { Loader } from '@components/Loader';
import { SecondaryButton } from '@components/SecondaryButton';
import { useCustomerProfileList } from '@hooks/CustomerProfile';
import { vendorRoutes } from '@routes/vendor';

import { CustomerProfileListItem } from '../components/CustomerProfileListItem';

export const CustomerProfileOverview = () => {
  const navigate = useNavigate();
  const { data: profiles = [], isLoading } = useCustomerProfileList();

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <SecondaryButton
          onClick={() => navigate(vendorRoutes.addCustomerProfile.path)}
          startIcon={<AddBoxIcon />}
          sx={{ marginBottom: '25px' }}
        >
          Add new customer profile
        </SecondaryButton>
      </Stack>

      {isLoading ? (
        <Loader text="Loading your customer profiles" />
      ) : (
        <Stack gap={2}>
          {profiles.map((profile) => (
            <CustomerProfileListItem key={profile.id} profile={profile} />
          ))}
        </Stack>
      )}
    </Box>
  );
};
